import { useEffect } from "react"
import Lenis from "lenis"

export type UseLenisOptions = {
  enabled?: boolean
}

export function useLenis(options: UseLenisOptions = {}): void {
  const { enabled = true } = options

  useEffect(() => {
    if (!enabled) return

    const lenis = new Lenis({
      duration: 1.5,
      syncTouch: true,
    })

    let rafId = 0
    const raf = (time: number) => {
      lenis.raf(time)
      rafId = requestAnimationFrame(raf)
    }
    rafId = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(rafId)
      lenis.destroy()
    }
  }, [enabled])
}
